<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-row>
            <v-col sm="3" md="3"></v-col>
            <v-col sm="6" md="6">
                <v-autocomplete :items="stud_list" v-model="stud_data" item-text="name" label="Search Student (PRN / Name)" dense
                    return-object outlined :loading="comp_load"
                    @change="getData"></v-autocomplete>
            </v-col>
            <v-col sm="3" md="3"></v-col>
        </v-row>
        <center v-if="current_academicyear">
            <strong>Details Shown For Academic Year-{{current_academicyear}}</strong>
        </center>
        <br />
        <student-profile-tab v-if="stud_data!=null" :lid="stud_data.lid"></student-profile-tab>

    </div>
</template>
<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

    import StudentProfileTabs from "./StudentProfileTabs";
    export default {
    components: {
          
            Breadcrumbs,
            "student-profile-tab": StudentProfileTabs,
        },
        data: () => ({
            comp_load: false,
            stud_list: null,
            stud_data: null, current_academicyear: "",
            // extraBreadcrumbItems: [
             

            // ],
            // breadcrumbClass: "breadcrumb-style1",
        }),
        mounted() {
            this.comp_load = true;
            axios
                .post("/admission/getAllStudents_edit_student")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.stud_list = res.data.stud_list;
                        this.current_academicyear = res.data.current_academicyear;
                    } else {
                        alert("Somthing went wrong!!!");
                    }
                })
                .catch((error) => {
                    alert("Somthing went wrong!!!");
                })
                .finally(() => {
                    this.comp_load = false;
                });
        },
        methods: {
            getData() {},
        },
    };
</script>
